import { useEffect, useRef } from 'react';

function useInterval(callback: Function, delay: number | null) {
  const savedCallback = useRef<Function>();
  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current!();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {};
  }, [delay]);
}

export default useInterval;
